export enum AnimalManagementConstants {
  ACTION_SET_ANIMAL_MANAGEMENT = 'ACTION_SET_ANIMAL_MANAGEMENT',
  REDUCER_SET_ANIMAL_MANAGEMENT = 'REDUCER_SET_ANIMAL_MANAGEMENT'
}

export type AnimalManagementStore = {
  animalManagementLoading: boolean
  messageRegister: string
}
